import React from 'react';
import styles from './index.module.scss';
import ModalPopup from '../ModalPopup';
import { trackPurchase, trackSubscribe } from '../../utils/analytics';

const CustomPopup = ({ visible, onClose }) => {
  const [email, setEmail] = React.useState('');
  const [tracked, setTracked] = React.useState(false);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedEmail = localStorage.getItem('userEmail') || '';
      setEmail(storedEmail);
    }

    // 支付成功页显示时上报埋点
    if (visible && !tracked) {
      // 上报支付成功埋点
      trackPurchase({
        value: 0.09,
        currency: 'USD',
        content_name: 'EBOOK',
        content_type: 'product'
      });

      // 上报订阅成功埋点
      trackSubscribe({
        value: 0.09,
        currency: 'USD',
        predicted_ltv: 0.09
      });

      setTracked(true);
    }
  }, [visible, tracked]);
  const [selected, setSelected] = React.useState(false);
  const handleContact = () => {
    if (typeof window !== 'undefined') {
      window.location.href = 'mailto:aistudyhub@outlook.com';
    }
  };

  const handleOpen = () => {
    if (typeof window !== 'undefined') {
      // 移动端优先 mailto，部分浏览器会自动唤起邮箱App
      window.location.href = `mailto:${email}`;
    }
  };
  return (
    <ModalPopup visible={visible} onClose={onClose}>
      <div className={styles.app}>
        <div className={styles.top}>
          <div className={styles.title}>Payment Successful!</div>
          <div className={styles.desc}>Thank you for your purchase. Your full eBook PDF is on the way!</div>
          <div className={styles.emailTitle}>We’ve sent the file to:</div>
          <div className={styles.emailInput}>{email}</div>

          <div className={styles.btnDesc}>
            If you don’t see it within 3 minutes, please check your Spam/Promotions tab or contact our support team.
          </div>
          <div className={styles.btn} onClick={handleOpen}>
            Open Email App
          </div>
          <div className={styles.btn2} onClick={handleContact}>
            Contact Support
          </div>
        </div>
      </div>
    </ModalPopup>
  );
};

export default CustomPopup;
